/**
 * API client for Health Tracker backend
 */
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL != null ? process.env.REACT_APP_API_URL : 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ========== Daily Metrics ==========
export const getDailyMetrics = async (params = {}) => {
  const response = await api.get('/api/metrics', { params });
  return response.data;
};

export const getDailyMetric = async (date) => {
  const response = await api.get(`/api/metrics/${date}`);
  return response.data;
};

export const createDailyMetric = async (data) => {
  const response = await api.post('/api/metrics', data);
  return response.data;
};

export const updateDailyMetric = async (date, data) => {
  const response = await api.put(`/api/metrics/${date}`, data);
  return response.data;
};

export const deleteDailyMetric = async (date) => {
  const response = await api.delete(`/api/metrics/${date}`);
  return response.data;
};

// ========== Analytics ==========
export const getDashboardSummary = async (userId = 1) => {
  const response = await api.get('/api/analytics/summary', {
    params: { user_id: userId }
  });
  return response.data;
};

export const getInsights = async (userId = 1) => {
  const response = await api.get('/api/analytics/insights', {
    params: { user_id: userId }
  });
  return response.data;
};

export const getWeeklyTrends = async (weeks = 12, userId = 1) => {
  const response = await api.get('/api/analytics/weekly', {
    params: { weeks, user_id: userId }
  });
  return response.data;
};

export const getCompleteAnalytics = async (weeks = 12, userId = 1) => {
  const response = await api.get('/api/analytics/complete', {
    params: { weeks, user_id: userId }
  });
  return response.data;
};

export const getTdee = async (windowDays = 30, userId = 1) => {
  const response = await api.get('/api/analytics/tdee', {
    params: { user_id: userId, window_days: windowDays }
  });
  return response.data;
};

export const getSettings = async () => {
  const response = await api.get('/api/settings');
  return response.data;
};

export const getWeightForecast = async (targetWeight, userId = 1) => {
  const response = await api.get('/api/analytics/forecast', {
    params: { user_id: userId, target_weight: targetWeight }
  });
  return response.data;
};

// ========== Data Import ==========
export const previewCSV = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post('/api/import/csv/preview', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const uploadCSV = async (file, sourceName = 'manual', userId = 1, skipToday = true) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post('/api/import/csv', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    params: {
      user_id: userId,
      source_name: sourceName,
      skip_today: skipToday
    }
  });
  return response.data;
};

export const getImportHistory = async (userId = 1, sourceId = null, limit = 50) => {
  const response = await api.get('/api/import/history', {
    params: { user_id: userId, source_id: sourceId, limit }
  });
  return response.data;
};

// ========== Health Check ==========
export const healthCheck = async () => {
  const response = await api.get('/health');
  return response.data;
};

export default api;
